<template>
  <h1>o dokhod</h1>
</template>

<script>
export default {

}
</script>

<style>

</style>
